import { type Attrs, type DOMOutputSpec, type Node, type NodeSpec } from "prosemirror-model";

// :: NodeSpec An image (`<image>`)

export const image: NodeSpec = {
	attrs: {
		src: { default: null },
		file: { default: null },
		width: { default: 600 },
		aspectRatio: { default: null },
		alignment: { default: "center" },
	},
	group: "block",
	parseDOM: [
		{
			// Images that were created by Moment will always have a
			// "file" data attr, so we check for those first, since they'll
			// have more detailed information
			tag: "img[data-file]",
			getAttrs(node: string | HTMLElement) {
				if (!(node instanceof HTMLElement)) {
					return false;
				}

				const attrs: Attrs = {
					src: node.getAttribute("src"),
					file: node.dataset["file"],
					width: node.getAttribute("width"),
					// @ts-ignore - TODO: fix type error of node.style["aspect-ratio"]
					aspectRatio: node.dataset["aspectRatio"] ?? node.style["aspect-ratio"],
					alignment: node.dataset["alignment"],
				};

				return attrs;
			},
		},
		{
			// We also want to support images that already exist in imported
			// docs, so we support normal image sources as well
			tag: "img[src]",
			getAttrs(node: string | HTMLElement) {
				if (!(node instanceof HTMLImageElement)) {
					return false;
				}

				const attrs: Attrs = {
					src: node.src,
					file: null,
					width: node.getAttribute("width"),
					// @ts-ignore - TODO: fix type error of node.style["aspect-ratio"]
					aspectRatio: node.dataset["aspectRatio"] ?? node.style["aspect-ratio"],
					alignment: node.dataset["alignment"],
				};

				return attrs;
			},
		},
	],
	toDOM(node: Node): DOMOutputSpec {
		const attrs = node.attrs;

		// Use the src directly if provided (for imported images),
		// otherwise use the file attribute with the related/ prefix (for Moment-created images)
		const src = attrs["src"] ?? `related/${attrs["file"]}`;

		return [
			"img",
			{
				"src": src,
				"data-file": attrs["file"],
				"width": attrs["width"],
				"style": `aspect-ratio: ${attrs["aspectRatio"]};`,
				"data-aspect-ratio": attrs["aspectRatio"],
				"data-alignment": attrs["alignment"],
			},
		];
	},
};
